module.exports = __webpack_public_path__ + "static/img/apple-button.5572174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-button.png
// module id = 9VDm
// module chunks = 0